import http, { CONFIG_QUERY } from "../network";

const getUserData = () =>
  Promise.all([http.get("/users/me"), http.get("/companies/me")]).then(
    ([user, company]) => ({
      ...user.data,
      company: company.data,
    })
  );

//

// eslint-disable-next-line import/prefer-default-export
export const QUERY_AUTH = {
  queryKey: "auth",
  queryFn: getUserData,
  config: {
    ...CONFIG_QUERY.infinite,
    enabled: false,
    initialData: {},
  },
};
